/** user roles */
export const IAR = "iar";
export const IAR_ASSISTANT = "iar_assistant";
export const IAR_PROSPECT = "iar_prospect";
export const CUSTODIAN = "custodian";
export const TPIA = "tpiatrader";
export const ADVISOR_ASSISTANT = "adv_assistant";
export const INTERNAL = "internal";
export const WHOLESALER = "wholesaler";
export const RIA_FIRM = "ria_firm";
export const CLIENT = "client";
export const RETAIL = "retail";
export const RETAIL_FP = "retail_fp";
export const BACK_OFFICE = "back_office";
export const FUNDBOARD = "fundboard";
export const CASE_MANAGER = "ssa_casemanager";
export const CONSULTANT = "ssa_consultant";
export const POLICYOWNER = "policyowner";
export const POTENTIALINSURED = "potentialinsured";
export const INVITED = "invite";
export const FINANCIALPROFESSIONAL = "financialproffesional";
export const POLICY_OWNER_FIND_MY_POLICY = "policyowner_findpolicy";
export const POLICY_OWNER_ACCOUNT_CREATION = "policyowner_accountcreation";
export const ANNUITIES_FP_PATH = "/retail";
export const RIA_PATH = "/";
export const MYACCOUNT_PATH = "/client";
export const BACKOFFICE_PATH = "/backoffice";
export const FUNDBOARD_PATH = "/fundboard";
export const ENTITY_OWNED_PATH = "/entity-owned";
export const TPIA_PATH = "/tpia";
export const INTERNAL_PATH = "/internal";
export const WHOLESALER_PATH = "/wholesaler";
export const RIA_FIRM_PATH = "/riafirm";
export const MY_TEAMS_ASSISTANT_PATH = "/myteamsassist";
export const SSA_PATH = "/ssa";
export const POLICYOWNER_ENROLL_URL = "/policyowner";
export const FP_ENROLL_URL = "/fp";
export const FP_LOGIN_URL = "/fp/login";
export const POTENTIAL_INSURED_URL = "/potentialinsured";
export const INVITEDUSER_ENROLL_URL = "/invite";
export const POLICYOWNER_ENROLL_2STEP_URL = "/policy-owner";
export const POLICYOWNER_TERMS_AND_CONDITIONS_URL = "/policyowner/";

export const HOME_URL_PATH = "/";
export const ANNUITIES_FP_LOGIN_PAGE_URL_PATH = "/home/misc/advisor-login.html";
export const RIA_LOGIN_PAGE_URL_PATH = "/home/misc/ria-login.html";
export const MYACCOUNT_LOGIN_PAGE_URL_PATH = "/home/misc/client-login.html";
export const FUNDBOARD_LOGIN_PAGE_URL_PATH = "/authenticate/login.html";
export const SSA_LOGIN_PAGE_URL_PATH = "/home/misc/ssa-login.html";

export const REGISTRATION_SUCCESSFUL_URL_PATH = "/home/misc/reg-successful.html";
export const REGISTRATION_PENDING_URL_PATH = "/home/misc/reg-pending.html";

export const PRIVACY_POLICIES_URL =
    "https://www.pacificlife.com/home/privacy-and-other-policies.html";
export const LEGAL_INFO_AND_WEBSITE_USAGE_URL =
    "https://www.pacificlife.com/home/privacy-and-other-policies/legal-information-and-website-usage.html";
export const ANNUITIES_GET_APPOINTED_URL =
    "https://www.annuities.pacificlife.com/home/working-with-us/get-appointed.html";
export const ANNUITIES_CONTACT_US_URL =
    "https://www.annuities.pacificlife.com/home/misc/reg-contact/reg-contact.html";
export const RIA_STRATEGIC_ALLIANCES_URL =
    "https://ria.pacificlife.com/home/why-us/strategic-alliances.html";

export const PL_LOGO_BLACK_URL =
    "https://ria.pacificlife.com/content/dam/paclife/rsd/annuities/images/logos/pl_horiz_bw.gif";

export const VERIFY_FIRM_ID_FOR_ROLES = new Set([TPIA, RIA_FIRM]);
export const VERIFY_ADVISOR_CRD_FOR_ROLES = new Set([TPIA]);

export const ROLE_OPTIONS = [
    {
        value: "iar",
        label: "Investment Advisory Representative (IAR)"
    },
    { value: "custodian", label: "Distribution Partner/Custodian" }
];

export const SSN_ROLE_OPTIONS = [
    {
        value: "ssa_consultant",
        label: "Consultant"
    },
    {
        value: "ssa_casemanager",
        label: "Case Manager"
    }
];

export const FP_ROLE_OPTIONS = [
    {
        value: "producer",
        label: "Producer/Advisor"
    },
    { value: "principal", label: "Principal" }
];

export const US_STATES = [
    { label: "Alabama", value: "AL" },
    { label: "Alaska", value: "AK" },
    { label: "Arizona", value: "AZ" },
    { label: "Arkansas", value: "AR" },
    { label: "California", value: "CA" },
    { label: "Colorado", value: "CO" },
    { label: "Connecticut", value: "CT" },
    { label: "Delaware", value: "DE" },
    { label: "District of Columbia", value: "DC" },
    { label: "Florida", value: "FL" },
    { label: "Georgia", value: "GA" },
    { label: "Hawaii", value: "HI" },
    { label: "Idaho", value: "ID" },
    { label: "Illinois", value: "IL" },
    { label: "Indiana", value: "IN" },
    { label: "Iowa", value: "IA" },
    { label: "Kansas", value: "KS" },
    { label: "Kentucky", value: "KY" },
    { label: "Louisiana", value: "LA" },
    { label: "Maine", value: "ME" },
    { label: "Maryland", value: "MD" },
    { label: "Massachussetts", value: "MA" },
    { label: "Michigan", value: "MI" },
    { label: "Minnesota", value: "MN" },
    { label: "Mississippi", value: "MS" },
    { label: "Missouri", value: "MO" },
    { label: "Montana", value: "MT" },
    { label: "Nebraska", value: "NE" },
    { label: "Nevada", value: "NV" },
    { label: "New Hampshire", value: "NH" },
    { label: "New Jersey", value: "NJ" },
    { label: "New Mexico", value: "NM" },
    { label: "New York", value: "NY" },
    { label: "North Carolina", value: "NC" },
    { label: "North Dakota", value: "ND" },
    { label: "Ohio", value: "OH" },
    { label: "Oklahoma", value: "OK" },
    { label: "Oregon", value: "OR" },
    { label: "Pennsylvania", value: "PA" },
    { label: "Rhode Island", value: "RI" },
    { label: "South Carolina", value: "SC" },
    { label: "South Dakota", value: "SD" },
    { label: "Tennessee", value: "TN" },
    { label: "Texas", value: "TX" },
    { label: "Utah", value: "UT" },
    { label: "Vermont", value: "VT" },
    { label: "Virginia", value: "VA" },
    { label: "Washington", value: "WA" },
    { label: "West Virgina", value: "WV" },
    { label: "Wisconsin", value: "WI" },
    { label: "Wyoming", value: "WY" }
];

export const REQUIRED_FIELDS = {
    [IAR]: [
        "firstName",
        "lastName",
        "email",
        "firmId",
        "crd",
        "contractNumber",
        "tin",
        "id"
    ],
    [IAR_PROSPECT]: [
        "firstName",
        "lastName",
        "email",
        "firmId",
        "crd",
        "id",
        "phone"
    ],
    [IAR_ASSISTANT]: [
        "firstName",
        "lastName",
        "email",
        "firmId",
        "ssn4",
        "dob",
        "id"
    ],
    [CUSTODIAN]: [
        "firstName",
        "lastName",
        "email",
        "firmId",
        "ssn4",
        "dob",
        "id"
    ],
    [TPIA]: ["firstName", "lastName", "email", "firmID", "userName"],
    [RIA_FIRM]: ["firstName", "lastName", "email", "firmID", "userName"],
    [INTERNAL]: ["firstName", "lastName", "email", "userName"],
    [WHOLESALER]: ["firstName", "lastName", "email", "userName"],
    [ADVISOR_ASSISTANT]: [
        "firstName",
        "lastName",
        "email",
        "fpFirstName",
        "fpLastName",
        "userName"
    ],
    [CLIENT]: ["firstName", "lastName", "email", "contractNumber", "tin", "id"],
    [RETAIL]: [
        "firstName",
        "lastName",
        "email",
        "tin",
        "userName",
        "contractNumber"
    ],
    [RETAIL_FP]: ["firstName", "lastName", "email", "id", "optionSelect"],
    [BACK_OFFICE]: ["firstName", "lastName", "email", "tin", "id"],
    [FUNDBOARD]: ["firstName", "lastName", "email", "id"],
    [CASE_MANAGER]: ["firstName", "lastName", "email", "id", "consultantName"],
    [CONSULTANT]: ["firstName", "lastName", "email", "id", "consultantName"],
    [POLICYOWNER]: [
        "tin",
        "dob",
        "policyNumber",
        "tinType",
        "firstName",
        "lastName",
        "email",
        "verifyEmail",
        "id"
    ],
    [INVITED]: [
        "policyNumber",
        "firstName",
        "lastName",
        "email",
        "verifyEmail",
        "id"
    ],
    [POTENTIALINSURED]: ["firstName", "lastName", "email", "verifyEmail"],
    [POLICY_OWNER_FIND_MY_POLICY]: ["tin", "dob", "policyNumber", "tinType"],
    [POLICY_OWNER_ACCOUNT_CREATION]: [
        "firstName",
        "lastName",
        "email",
        "verifyEmail",
        "id"
    ],
    [FINANCIALPROFESSIONAL]: [
        "tin",
        "zipCode",
        "firstName",
        "lastName",
        "email",
        "verifyEmail",
        "id",
        "state"
    ]
};
